import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export function formatDate(date: Date | string): string {
  if (!date) return '';

  const parsedDate = new Date(date);
  return parsedDate.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function excelExport(
  data: object[],
  columnMapping: object,
  worksheetName: string,
  fileName: string
) {
  const exportData = data.map(item => {
    const exportItem = {};

    // Nur ausgewählte Spalten exportieren und umbenennen
    Object.keys(columnMapping).forEach(key => {
      if (key === 'createdOn') {
        exportItem[columnMapping[key]] = formatDate(item[key]);
      } else {
        exportItem[columnMapping[key]] = item[key];
      }
    });

    return exportItem;
  });

  // Arbeitsblatt erstellen
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

  // Arbeitsmappe erstellen
  const workbook: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, worksheetName);

  // Excel-Datei generieren
  const excelBuffer: BlobPart = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  // Datei speichern
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, fileName);
}

export function nowTimestamp() {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  const YYYY = d.getFullYear();
  const MM = pad(d.getMonth() + 1);
  const DD = pad(d.getDate());
  const hh = pad(d.getHours());
  const mm = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${YYYY}-${MM}-${DD} ${hh}-${mm}-${ss}`;
}
